import { useCallback, useEffect, useMemo, useRef } from 'react';
import { useLocation } from 'react-router';

import { AlertModal } from '@portal/common/components';
import usePersistedState from '@portal/common/utility/use-persisted-state';

import _ from '../../locale';
import { getLocalStorageItem } from '../../services/localStorageService';
import { getDataToolLabelKey } from '../../utility/data-tools-paths';
import { checkIsTabletDevice } from '../../utility/detect-device';
import usePortraitOrientation from '../../utility/hook/use-portrait-orientation';

const DISMISSED_STORAGE_KEY = 'rotateDeviceNoticeDismissed';

const RotateDeviceNoticeModal = () => {
    const { pathname } = useLocation();
    const [isDismissed, setIsDismissed] = usePersistedState(DISMISSED_STORAGE_KEY, false);

    const dataToolLabelKey = getDataToolLabelKey(pathname);
    const isEnabled = !isDismissed && !!dataToolLabelKey;
    const isPortrait = usePortraitOrientation(isEnabled);
    const isVisible = isEnabled && isPortrait === true;

    const wasVisibleRef = useRef(false);

    const dataToolNameRef = useRef('');
    if (dataToolLabelKey) {
        dataToolNameRef.current = _(dataToolLabelKey);
    }

    useEffect(() => {
        if (isVisible) {
            wasVisibleRef.current = true;
        } else if (wasVisibleRef.current && isPortrait === false) {
            setIsDismissed(true);
        }
    }, [isVisible, isPortrait, setIsDismissed]);

    const handleDismiss = useCallback(() => setIsDismissed(true), [setIsDismissed]);

    return (
        <AlertModal
            isVisible={isVisible}
            title={_('rotate_device_notice_title')}
            message={_('rotate_device_notice_message', { tool: dataToolNameRef.current })}
            submitLabel={_('rotate_device_notice_button')}
            onSubmit={handleDismiss}
            onClose={handleDismiss}
        />
    );
};

const RotateDeviceNotice = () => {
    const isEligible = useMemo(
        () => checkIsTabletDevice() && !getLocalStorageItem(DISMISSED_STORAGE_KEY),
        []
    );

    return isEligible ? <RotateDeviceNoticeModal /> : null;
};

export default RotateDeviceNotice;
